import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { ee } from '../constants';
import { MenuItem } from '../types';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  standalone: false
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  @Input() menuItems: [ ...MenuItem ];
  @Input() currentContent: string;
  name: string;

  constructor() { }

  ngOnInit(): void {
    // These 2 lines are executed once (first load)
    let found = this.menuItems.find(item => item.link === this.currentContent);
    this.name = found.name;
    // These lines are executed on each event fired (page change)
    ee.on('changeContent', (data: string) => {
      this.currentContent = data;
      found = this.menuItems.find(item => item.link === this.currentContent);
      this.name = found?.name;
    });
  }

  ngOnDestroy(): void {
    ee.off('changeContent', () => {});
  }

}
